import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Formik } from 'formik';
import { updateUser, getuserdetailsbyid, updateUserbyadmin } from '../../shared/api/user';
import { inputLabelClasses } from "@mui/material/InputLabel";
import EditIcon from '@mui/icons-material/Edit';
import "./Edit-User.css";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useRef } from 'react';
import { uploadImage, } from '../../shared/api/user';
import defaultCover from '../../shared/images/default-cover.png'
import { useParams } from 'react-router-dom';

const style = {
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: "#CB2704"
    }
  }
}
const theme = createTheme();

export default function SignUp() {
  const [User, setUser] = useState([]);
  const navigate = useNavigate();
  const [UpdatePicture, setUpdatePicture] = React.useState(false);
  const [UpdateCover, setUpdateCover] = React.useState(false);
  const [onFileSelect, setonFileSelect] = useState();
  const [onCoverSelect, setonCoverSelect] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCoverImage, setSelectedCoverImage] = useState(null);
  const [err, seterr] = useState('');
  let { id } = useParams();

  const init = async () => {
    let user = await getuserdetailsbyid(id);
    setUser(user.data.user[0]);
  }

  useEffect(() => {
    init();
  }, []);

  const handleClickClosed = () => {
    setUpdatePicture(false)
    setUpdateCover(false);
  };

  const fileInputRef = useRef(null);

  const handleFileSelect = async () => {
    fileInputRef.current.click();

  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setonFileSelect(selectedFile);
    setSelectedImage(URL.createObjectURL(selectedFile));
  };

  const handleCoverChange = (e) => {
    const selectedCoverImage = e.target.files[0];
    setonCoverSelect(selectedCoverImage);
    setSelectedCoverImage(URL.createObjectURL(selectedCoverImage));
  };

  const Submit = async () => {
    if (selectedImage) {
      const formData = new FormData();
      formData.append("file", onFileSelect);
      let res = await uploadImage(formData);
      let url = res.data.data.url;
      await updateUserbyadmin(User._id, { picture: url });
      setUpdatePicture(false);
      window.location.reload();
    }
    else {
      seterr("Select a picture before submitting..!");
    }
  }

  const SubmitCover = async () => {
    if (selectedCoverImage) {
      const formData = new FormData();
      formData.append("file", onCoverSelect);
      let res = await uploadImage(formData);
      let url = res.data.data.url;
      await updateUserbyadmin(User._id, { coverPhoto: url });
      setUpdatePicture(false);
      window.location.reload();
    }
    else {
      seterr("Select a picture before submitting..!");
    }
  }

  const OpenpicDialoge = () => {
    setUpdatePicture(true)

  }

  const OpenCoverDialoge = () => {
    setUpdateCover(true)

  }
  if (!User.email) {
    return <Box display="flex"
      justifyContent="center"
      alignItems="center">Loading</Box>
  }
  return (
    <ThemeProvider theme={theme}>
      <Container className='edit-prof-cnt' component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 12,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
          >
          <img style={{ height: "85px", width: "85px", borderRadius: "50%", zIndex: '10000' }} src={User.picture} ></img>
          <Dialog open={UpdatePicture} onClose={handleClickClosed}>
            <DialogTitle>Update Picture</DialogTitle>
            <DialogContent>
              <div className='update-pic-dialoge'>
                <p className='update-pic-p'>Drop your photo here, or
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                  <button onClick={handleFileSelect} className='update-pic-Browse-btn'>Browse</button> <br></br> JPG or PNG format Max 5 MB.</p>
              </div>
              {selectedImage && <img className='update-pic-preview' src={selectedImage} alt="Selected" />}
            </DialogContent>
            <div className='error-message'>{err}</div>
            <DialogActions>
              <Button onClick={handleClickClosed}>Cancel</Button>
              <Button onClick={Submit}>Submit</Button>
            </DialogActions>
          </Dialog>
          <Typography sx={{ mt: 2, mb: 2, fontWeight: '600' }} component="h1" variant="h5">
            Update Profile
          </Typography>
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Formik initialValues={{ firstName: User.firstName, lastName: User.lastName, email: User.email, paypalEmail: User.paypalEmail, experience: User.experience, about: User.about, restaurantName: User.restaurantName, customServiceFee: User.customServiceFee }}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(async () => {
                    console.log(values)
                    setSubmitting(false);
                    let res = await updateUserbyadmin(User._id, values);
                    console.log(res)
                    window.location.reload();
                  }, 400);
                }}
              >
                {({ handleSubmit, handleChange, isSubmitting, enableReinitialize, values }) => (
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}>
                    {
                      User.chefType === 'PROFESSIONAL_CHEF' &&
                      <Box sx={{ display: 'flex', mb: 2, justifyContent: 'space-between' }}>
                        <Grid item xs={11} sm={5}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704"
                                }
                              }
                            }}
                            autoComplete="given-name"
                            name="firstName"
                            placeholder='First Name'
                            value={values.firstName}
                            fullWidth
                            id="firstName"
                            autoFocus
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={11} sm={5}>
                          <TextField
                            sx={style}
                            InputLabelProps={{
                              sx: {
                                [`&.${inputLabelClasses.shrink}`]: {
                                  color: "#CB2704"
                                }
                              }
                            }}
                            fullWidth
                            placeholder='Last Name'
                            id="lastName"
                            name="lastName"
                            value={values.lastName}
                            autoComplete="family-name"
                            onChange={handleChange}
                          />
                        </Grid>
                      </Box>
                    }


                    {
                      User.chefType === 'RESTAURANT' &&
                      <Grid sx={{ mb: 2 }} item xs={12}>
                        <TextField
                          sx={style}
                          InputLabelProps={{
                            sx: {
                              [`&.${inputLabelClasses.shrink}`]: {
                                color: "#CB2704"
                              }
                            }
                          }}
                          fullWidth
                          id="restaurantName"
                          name='restaurantName'
                          placeholder='Restaurant Name'
                          value={values.restaurantName}
                          onChange={handleChange}
                        />
                      </Grid>
                    }

                    <Grid sx={{ mb: 2 }} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704"
                            }
                          }
                        }}
                        fullWidth
                        id="email"
                        name="email"
                        placeholder='Email'
                        value={values.email}
                        autoComplete="email"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid sx={{ mb: 2 }} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704"
                            }
                          }
                        }}
                        fullWidth
                        id="paypalEmail"
                        name='paypalEmail'
                        placeholder='Paypal Email'
                        value={values.paypalEmail}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid sx={{ mb: 2 }} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704"
                            }
                          }
                        }}
                        fullWidth
                        id="about"
                        name='about'
                        placeholder='Description'
                        value={values.about}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid sx={{ mb: 2 }} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704"
                            }
                          }
                        }}
                        fullWidth
                        id="experience"
                        name='experience'
                        placeholder='Experience'
                        value={values.experience}
                        onChange={handleChange}
                      />
                    </Grid>

                    <Grid sx={{ mb: 2 }} item xs={12}>
                      <TextField
                        sx={style}
                        InputLabelProps={{
                          sx: {
                            [`&.${inputLabelClasses.shrink}`]: {
                              color: "#CB2704"
                            }
                          }
                        }}
                        fullWidth
                        id="customServiceFee"
                        name='customServiceFee'
                        placeholder='Service fee'
                        value={values.customServiceFee}
                        onChange={handleChange}
                      />
                    </Grid>

                    <Button
                      type="submit" disabled={isSubmitting}
                      fullWidth
                      variant="contained"
                      sx={{ mt: 2, mb: 2, background: '#CB2704', "&:hover": { background: "red" } }}
                    >
                      Submit
                    </Button>
                  </form>)}

              </Formik>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}